import React from 'react';
import PropTypes from 'prop-types';
import CustomerPaymentView from '../../components/CustomerPaymentView';
import Icon, { GLYPHS } from '../../../common/icon';

const ReceiptSent = ({ type, total }) => (
  <CustomerPaymentView
    total={total}
    subtitle="Receipt successfully sent"
  >
    <div className="c-customer-view-panel">
      <div display-if={type === 'email'}>
        <div className="c-receipt-icon">
          <Icon className="c-receipt-icon__glyph" glyph={GLYPHS.emailThick} />
        </div>
        <p className="c-receipt-message" data-automation-id="text:emailSent">Email Sent</p>
      </div>
      <div display-if={type !== 'email'}>
        <div className="c-receipt-icon">
          <Icon className="c-receipt-icon__glyph" glyph={GLYPHS.messageRound} />
        </div>
        <p className="c-receipt-message" data-automation-id="text:messageSent">Message Sent</p>
      </div>
    </div>
  </CustomerPaymentView>
);
ReceiptSent.propTypes = {
  type: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
};

export default ReceiptSent;
